<template>
    <div class="reset">
      <label for="reset-password" class="form-label"><h5>重設密碼</h5></label>
      <form @submit.prevent="resetPassword">
        <div class="input-group mb-3">
          <input type="text" class="form-control" id="reset-password" placeholder="欲重置密碼之信箱帳號" v-model="email" required>
          <button type="submit" class="btn btn-warning">重設</button>
        </div>
      </form>
    </div>
    <div class="note">
      <span id="title">※密碼會重置成信箱帳號</span><br/>
      <span id="example">例如: 信箱為test@gmail.com，重置後密碼為test@gmail.com</span>
    </div>
</template>
<script setup>
import axios from 'axios';
import { ref } from 'vue';

const email = ref('');

const resetPassword = async () => {
  try {
    const response = await axios.post(
      'https://baofengbooks.com/s_api/public/api/reset-password',
      {
        email: email.value
      }
    );
    if(response.data) {
      console.log('註冊成功');
      alert('重置成功');
      window.location.reload();
    }
  } catch (error) {
    console.error(error.response || error);
    alert('重置失敗');
  }
};
</script>
<style scoped>
  button{
    font-weight: 600;
  }
  h5{
    font-weight: 600;
  }
  .note{
    text-align: start;
    padding-left: 10px;
  }
  #title{
    font-weight: 600;
    font-size: 15px;
    color: rgb(177, 20, 20);
  }
  #example{
    font-weight: 500;
    font-size: 14px;
    color: rgb(114, 114, 114);
  }
</style>
  